// Canonical-доступ к Capacitor-плагинам.
//
// Почему не `await import("@capacitor/<plugin>")`:
//   • со specifier'ом через переменную Rollup не может разрешить импорт на
//     сборке и оставляет bare specifier в бандле — в WebView он не резолвится
//     (import map отсутствует), промис отклоняется, вызывающий уходит в catch
//     и получает МОЛЧАЛИВУЮ деградацию;
//   • со строковым литералом модуль попадает в бандл и работает, но тогда
//     @capacitor/* обязан быть зависимостью пакета, а web-сборка тащит код
//     нативных плагинов впустую.
//
// Capacitor 8: нативный мост заполняет PluginHeaders, а `Plugins[name]`
// появляется только после `registerPlugin`. Читать map без регистрации —
// ложный «плагин недоступен». Тот же helper (с тем же обоснованием) живёт в
// apps/mobile/src/capacitor-plugins.ts — продублирован намеренно: пакеты не
// зависят друг от друга.

interface CapacitorBridge {
	Plugins?: Record<string, unknown>;
	registerPlugin?: (name: string) => unknown;
	isPluginAvailable?: (name: string) => boolean;
}

function getCapacitorBridge(): CapacitorBridge | null {
	if (typeof window === "undefined") return null;
	return (window as unknown as { Capacitor?: CapacitorBridge }).Capacitor ?? null;
}

export function getCapacitorPlugin<T>(name: string): T | null {
	const cap = getCapacitorBridge();
	if (!cap) return null;

	const existing = cap.Plugins?.[name];
	if (existing) return existing as T;

	if (typeof cap.registerPlugin !== "function") return null;
	if (typeof cap.isPluginAvailable === "function" && !cap.isPluginAvailable(name)) {
		return null;
	}

	try {
		return (cap.registerPlugin(name) as T) ?? null;
	} catch {
		return null;
	}
}
